import React from 'react';
import { Router } from 'react-router';
import { Provider } from 'react-redux';
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';

import {
    middleware as analyticsMiddleware,
    GA_SETTINGS_PROP_TYPE,
} from '@eb/site-analytics';

import { configureStore } from 'js-utils/redux';
import reducer from './reducers';
import { getInitialState } from './reducers/utils';
import { getHistory, updateHistory } from 'js-utils/router';
import getRoutes from './routes';

export default class UserCollectionsApp extends React.Component {
    static propTypes = {
        gaSettings: GA_SETTINGS_PROP_TYPE,
    };

    constructor(props) {
        super(props);

        // create a history object depending on the environment
        // server-side: dummy/memory history
        // client-side: browser history
        this._history = getHistory();

        // creates a store w/ Redux logging defaulted in development environment
        // also adds `redux-thunk` middleware by default for async actions
        this._store = configureStore({
            reducer,
            initialState: getInitialState(props),
            middleware: [
                thunk,
                routerMiddleware(this._history),
                analyticsMiddleware(this.props),
            ],
        });

        // make the store the source of truth for the current route we're on
        this._history = syncHistoryWithStore(this._history, this._store);

        // sync the server-side request information w/ the history to make sure
        // we render the correct initial route
        updateHistory(this._history, props.request);
    }

    componentWillReceiveProps({ request }) {
        // any time we update the App's props after initial render (which really should be never)
        // make sure we also update the history with any changes in the request
        updateHistory(this._history, request);
    }

    render() {
        const routes = getRoutes(this.props);

        return (
            <Provider store={this._store}>
                <Router history={this._history} routes={routes} />
            </Provider>
        );
    }
}
